<template>
  <v-dialog v-model="isOpen" max-width="550">      
      <v-card>
        <v-card-title class="headline grey lighten-3">{{currentInfosDialog.title}}</v-card-title>
        <v-card-text>
          <p class="content" v-html="currentInfosDialog.infos"></p>
          <a target="blank" :href="currentInfosDialog.urlinfos" v-if="currentInfosDialog.urlinfos" >{{$t('App.GoToSite')}}</a>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary darken-1" flat="flat" @click="isOpen = false" >{{$t('App.Close')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>
<script>
  import { mapGetters } from 'vuex'        

  export default {    
    name: 'AppInfosDialogContainer',     
    computed: {
       ...mapGetters([
         'currentInfosDialog'
        ]),
        isOpen:{
          get(){
            return this.currentInfosDialog.isVisible
          },
          set(newValue){
            this.$store.myActions.UI_SET_INFOS_DIALOG_VISIBILITY(newValue)
          }
        }         
    },
    methods: {    
    }
  }
</script>
<style scope>
.content{
  word-wrap: break-word;
}
</style>